<template lang="html">
  <div>
    <div class="vld-parent">
      <v-overlay :value="isLoading">
        <v-progress-circular
          indeterminate
          size="64"
        />
      </v-overlay>
    </div>    
    <v-navigation-drawer
      v-model="drawer"      
      app
      right
      width="550"
      temporary
      hide-overlay
    >
      <v-toolbar
        color="success" 
        dark
      >
        <v-toolbar-title class="white--text">
          Advanced Filter
        </v-toolbar-title>
      </v-toolbar>
      <v-container> 
        <v-row>
          <v-col cols="12"> 
            <v-autocomplete
              v-model="branch"
              :items="branches"              
              label="Branch"
              placeholder="Branch Access"
              item-text="branch_name"
              item-value="branch_uid"              
              hide-no-data
              hide-selected
              chips
              multiple
              deletable-chips
            />
          </v-col>
          <v-col cols="12"> 
            <v-autocomplete
              v-model="crm"
              :items="crmRoles"              
              label="CRM"
              placeholder="CRM Roles"
              item-text="name"
              item-value="id"
              hide-no-data
              hide-selected
              chips
              multiple
              deletable-chips
            />
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="ams"
              :items="amsRoles"              
              label="AMS"
              placeholder="AMS Roles"
              item-text="name"
              item-value="id"
              hide-no-data
              hide-selected
              chips
              multiple  
              deletable-chips
            />
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="hrm"
              :items="hrmRoles"              
              label="Workspace"
              placeholder="Workspace Roles"
              item-text="name"
              item-value="id"
              hide-no-data
              hide-selected
              chips
              multiple
              deletable-chips
            />
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="lmspro"
              :items="lmsproRoles"              
              label="LMS PRO"
              placeholder="LMS PRO Roles"
              item-text="name"
              item-value="id"
              hide-no-data
              hide-selected
              chips
              multiple
              deletable-chips
            />
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="position"
              :items="positions"              
              label="Position"
              placeholder="Positions"
              item-text="name"
              item-value="id"
              hide-no-data
              hide-selected
              chips
              multiple
              deletable-chips
            />
          </v-col>
          <v-col cols="12">
            <v-autocomplete 
              v-model="company"
              :items="companies"
              label="Payroll Company"
              placeholder="Payroll Company"
              chips
              multiple
              deletable-chips
              hide-no-data
              hide-selected
              item-text="name"
              item-value="id"
            />
          </v-col>
          <v-col
            cols="12"
            class="text-center"
          >
            <v-btn
              block
              color="success"
              @click="loadUserOverview"
            >
              Search
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-navigation-drawer>

    <v-container
      v-show="!isProfile"    
      fluid
    >
      <v-row>
        <v-col cols="12">
          <v-skeleton-loader
            :loading="skeleton"
            type="table-heading, table-thead, table-row-divider@9, table-tfoot"
            min-height="657px"
            elevation="5"
          >
            <v-card>
              <v-toolbar
                flat
                color="white"
              >
                <v-text-field
                  v-model="searchInput"
                  append-icon="search"
                  placeholder="Search by name or username"
                  single-line
                  hide-details
                />
                <v-spacer />      
                <v-tooltip
                  v-if="filterOn"
                  content-class="bottom"
                  bottom
                >
                  <template v-slot:activator="{ on }">
                    <v-btn   
                      text
                      icon           
                      color="primary"
                      v-on="on"
                      @click="clearFilter"
                    >
                      <v-icon 
                        color="error"                      
                        medium
                      >
                        mdi-close
                      </v-icon>
                    </v-btn> 
                  </template>
                  <span>Clear filter</span>
                </v-tooltip>

                <v-tooltip
                  content-class="bottom"
                  bottom
                >
                  <template v-slot:activator="{ on }">
                    <v-btn   
                      text
                      icon           
                      color="primary"
                      v-on="on"
                      @click.stop="drawer = true"
                    >
                      <v-icon 
                        v-if="isFiltering" 
                        medium
                      >
                        filter_list_alt
                      </v-icon>
                      <v-icon 
                        v-else
                        medium
                      >
                        filter_list
                      </v-icon>
                    </v-btn> 
                  </template>
                  <span>Advanced filter</span>
                </v-tooltip>
              
                <v-btn 
                  v-show="$hasPermissionTo(['create employees section'])"
                  class="mx-2"
                  color="success" 
                  @click="$refs.stepper.toggleDialog()"
                >
                  Create Employee
                </v-btn>

                <v-tooltip
                  content-class="bottom"
                  bottom
                >
                  <template v-slot:activator="{ on }">
                    <v-avatar 
                      class="cursor-pointer"
                      v-on="on"
                      @click="loadUserOverview"
                    >
                      <v-icon medium>
                        mdi-refresh
                      </v-icon>
                    </v-avatar>
                  </template>
                  <span>Reload</span>
                </v-tooltip>
              </v-toolbar>
              <v-data-table
                :loading="tableLoading"
                :headers="filteredHeaders"
                :items="employees"
                :custom-sort="customSort"
                hide-default-footer
                :page.sync="currentPage"
                :items-per-page="itemsPerPage"
                item-key="user_uid"
              >            
                <v-progress-linear
                  v-slot:progress
                  color="blue"
                  indeterminate
                />
                <template v-slot:item="props">
                  <tr>
                    <td>
                      <v-avatar
                        color="teal"
                        size="40"
                        @click="handleRowOnClick(props)"
                      >
                        <img 
                          v-if="props.item.thumbnail_url !== ''"
                          :src="props.item.thumbnail_url" 
                          alt="avatar"
                        >
                        <span 
                          v-else 
                          class="white--text headline"
                        >{{ (props.item.person || {}).name.match(/\b\w/g).slice(0, 1).join('') }}
                        </span>
                      </v-avatar>

                      <a
                        style="margin-left:10px;color:black;font-weight:bold" 
                        @click="handleRowOnClick(props)"
                      >
                        {{ (props.item.person || {}).name }}                      
                      </a>
                    </td>
                    <td>
                      <v-icon
                        v-if="props.item.person !== null"
                        :class="props.item.person.gender === 'Male' ? 'blue--text' : 'red--text'"
                      >
                        {{ props.item.person.gender === 'Male' ? 'mdi-gender-male' : 'mdi-gender-female' }}
                      </v-icon>
                    </td>
                    <td> 
                      {{ ((props.item.current_position || {}).position || {}).name }} 
                    </td>
                    <td> {{ ((props.item.person || {}).user || {}).username }} </td>
                    <td>
                      <div v-if="props.item.is_active_employment">
                        <v-fade-transition>
                          <v-avatar
                            :style="{
                              animationDuration: `0.9s`
                            }"
                            :color="getStatusColor(props.item)"
                            class="mb-1 v-avatar--metronome"
                            size="12"
                          />
                        </v-fade-transition>
                        <span 
                          class="ml-1 green--text"
                        > Active </span>
                      </div>
                      <div v-else>
                        <v-fade-transition>
                          <v-avatar
                            :style="{
                              animationDuration: `5s`
                            }"
                            :color="getStatusColor(props.item)"
                            class="mb-1 v-avatar--metronome"
                            size="12"
                          />
                        </v-fade-transition>         
                        <span 
                          v-if="isResigned(props.item)" 
                          class="ml-1 grey--text"
                        > 
                          {{ 
                            props.item.current_separation ? props.item.current_separation.type.name : 'Resignation' }} 
                        </span>
                        <span 
                          v-else-if="isPending(props.item)" 
                          class="ml-1 warning--text"
                        > Pending </span>
                        <span 
                          v-else 
                          class="ml-1 info--text"
                        > On Leave </span>
                      </div>
                    </td>
                    <td>
                      <user-password-dialog-edit 
                        v-if="canEditPassword()"
                        :old-password-required="false"
                        :user="(props.item.person || {}).user"
                      >
                        <template v-slot:trigger>
                          <v-btn
                            :disabled="!(canEditPassword() && (props.item.person||{}).user)"
                            color="success"
                            rounded
                            small
                          >
                            Change Password
                          </v-btn>
                        </template>
                      </user-password-dialog-edit> 
                    </td>
                  </tr>
                </template>            
              </v-data-table>
              <v-divider class="ml-0 mr-0" />
              <v-container
                v-if="finishLoading"
                class="align-right"
              >
                <v-btn
                  icon
                  color="primary"
                  :disabled="currentPage === 1"
                  @click="previousPage"
                >
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <span
                  class="pagination"
                >{{ from }}-{{ to }} of {{ total }}</span>
                <v-btn
                  icon
                  color="primary"
                  :disabled="currentPage === lastPage"
                  @click="nextPage"
                >
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-container>
            </v-card>
            <user-stepper-create
              ref="stepper"
              @refreshList="loadUserOverview"
              @openProfile="openProfile"
            />
          </v-skeleton-loader>  
        </v-col>
      </v-row>
    </v-container>
    <v-fade-transition>
      <employee-profile-view 
        v-show="isProfile"
        :employee-uid="employee.employee_uid"
        :person-uid="person.person_uid"
        :user-uid="user.user_uid"
      >
        <template v-slot:navigation>
          <v-breadcrumbs 
            :items="navItems" 
            divider="/"
            class="py-0"
          >
            <template v-slot:item="props">
              <a  
                :class="[props.item.disabled && 'disabled']"
                @click="updatePage"
              >{{ props.item.text }}</a>
            </template>
          </v-breadcrumbs>
        </template>
      </employee-profile-view>
    </v-fade-transition>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    components: {
      EmployeeProfileView: () => import('@/components/employee/ProfileView'),
      UserPasswordDialogEdit: () => import('@/components/user/PasswordDialogEdit'),
      UserStepperCreate: () => import('@/components/user/StepperCreate'),
    },

    inject: ['theme'],
    metaInfo () {
      return {
        title: 'Employee Management',
      }
    },
    data () {
      return {      
        headers: [
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Gender',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Position',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Username',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Status',
            align: 'left',
            value: 'status',
            sortable: false,
          },
        ],
        searchInput: '',
        itemsPerPage: 10,
        employees: [],
        employee: {},
        person: {},
        user: {},
        skeleton: true,
        tableLoading: false,
        isLoading: false,
        isProfile: false,

        // profile navigation
        navItems: [
          {
            text: 'Overview',
            disabled: false,
            to: { path: '/employees' }, 
            exact: true,
          },
          {
            text: 'Profile',
            disabled: true,
          },
        ],
        total: 0,
        from: 0,
        to: 0,
        lastPage: 0,
        finishLoading: false,

        loadedPage: 1,
        currentPage: 1,
        drawer: null,

        branches: [],
        amsRoles: [],
        crmRoles: [],
        hrmRoles: [],
        lmsproRoles: [],
        positions: [],
        companies: [],

        crm: null,
        ams: null,
        branch: null,
        hrm: null,
        lmspro: null,
        position: null,
        company: null,
      }
    },
    computed: {

      filteredHeaders () {
        return this.canEditPassword() ? [...this.headers, { value: '' }] : this.headers
      },
      isFiltering () {
        return !_.isEmpty(this.crm) || 
          !_.isEmpty(this.ams) || 
          !_.isEmpty(this.branch) || 
          !_.isEmpty(this.hrm) || 
          !_.isEmpty(this.lmspro) || 
          !_.isEmpty(this.position) ||
          !_.isEmpty(this.company)
      },

      filterOn () {
        return !_.isEmpty(this.crm) || 
          !_.isEmpty(this.ams) || 
          !_.isEmpty(this.branch) || 
          !_.isEmpty(this.hrm) || 
          !_.isEmpty(this.lmspro) || 
          !_.isEmpty(this.position) ||
          !_.isEmpty(this.company)
      },
    },
    watch: {
      searchInput (val) {
        this.tableLoading = true
        clearTimeout(this._searchTimerId)
        this._searchTimerId = setTimeout(() => {
          this.loadUserOverview()
        }, 1000) /* 1000ms throttle */
      },
    },
    created () {
      this.$store.state.isMyProfile = false

      this.getStates()
      this.getCities()
      this.getPostcodes()

      this.$api.branches().list()
        .then(response => {
          this.branches = response.data
        })      
      this.$api.roles('ams').list()
        .then(response => {
          this.amsRoles = response.data
        })
      this.$api.roles('crm').list()
        .then(response => {
          this.crmRoles = response.data
        })
      this.$api.roles('hrm').list()
        .then(response => {
          this.hrmRoles = response.data
        })
      this.$api.roles('lmspro').list()
        .then(response => {
          this.lmsproRoles = response.data
        })
      this.$api.positions().list()
        .then(response => {
          this.positions = response.data
        })
      this.$api.companies().list()
        .then(response => {
          this.companies = response.data
        })
    },
    mounted () {
      this.loadUserOverview()
    },
    methods: {
      ...mapActions('lookup', ['getStates', 'getCities', 'getPostcodes']),
      loadUserOverview (userUid = null) {
        this.tableLoading = true

        this.$api.employees().overview('', this.prepareFormData())
          .then(res => {
            this.setPaginationDetails(res.data)
            this.employees = res.data.data
            this.tableLoading = false
            this.skeleton = false
            this.finishLoading = true
          })
      },
      updatePage () {
        let currentEmployeeUid = this.employee.employee_uid

        this.$api.employees().showOverview(currentEmployeeUid)
          .then(response => {
            this.$set(this.employees, this.employees.findIndex(employee => employee.employee_uid === currentEmployeeUid), response.data)
          })

        this.isProfile = false
      },     
      handleRowOnClick (props) {
        if (this.isVessel(props)) {
          this.openProfile(props.item)
          return
        }

        this.validateEmployeeStatus(props)
      },
      validateEmployeeStatus (props) {
        this.isLoading = true

        this.$api.userPermissions().show(((props.item.person || {}).user || {}).user_uid, 'orgchart superman')
          .then(response => {
            this.openProfile(props.item)          
          })
          .catch(err => {
            if (err.response.status === 404) {
              this.validateStepperStatus(props)
            }
          })
          .then(() => {
            this.isLoading = false
          })
      }, 
      validateStepperStatus (props) {
        this.isLoading = true

        Promise.all([
          this.$api.reportTo().show(props.item.employee_uid),
        ])
          .then(([reportToResponse]) => {
            let reportTo = reportToResponse.data

            this.isLoading = false

            if (
              // || !this.hasActiveBranch(props) 
              (!this.hasPerson(props) || !this.hasReportTo(reportTo)) && 
              this.$hasPermissionTo(['create employees section']) 
            ) {
              this.$refs.stepper.toggleDialog(props.item, reportTo.person)
            } else {                 
              this.openProfile(props.item)
            }
          })
          .catch(() => {
            if (this.$hasPermissionTo(['create employees section'])) {
              this.$refs.stepper.toggleDialog(props.item, undefined)
            }
          })
      },
      getStatusColor (employee) {
        if (this.isResigned(employee)) {
          return 'grey'
        } else if (this.isPending(employee)) {
          return 'warning'
        } else if (this.isOnLeave(employee)) {
          return 'info'
        } else {
          return 'green'
        }
      },
      isResigned (employee) {
        return employee.end_date !== null && employee.end_date <= this.$moment().format('YYYY-MM-DD')
      },
      isPending (employee) {
        return employee.joined_date > this.$moment().format('YYYY-MM-DD')
      },
      isOnLeave (employee) {
        return employee.is_active === 0
      },
      getEmployeeStatus (employee) {
        if (employee.end_date !== null && employee.end_date <= this.$moment().format('YYYY-MM-DD')) return 3 // resigned

        if (employee.joined_date > this.$moment().format('YYYY-MM-DD')) return 2 // pending

        if (employee.is_active === 0) return 1 // on leave

        return 0 // active
      },
      canEditPassword () {
        return this.$hasPermissionTo(['update whole users'])
      },

      customSort (items, index, isDesc) {      
        items.sort((a, b) => {
          if (index[0] === 'status') {        
            if (isDesc[0]) {
              return this.getEmployeeStatus(b) < this.getEmployeeStatus(a) ? -1 : 1            
            } else { 
              return this.getEmployeeStatus(a) < this.getEmployeeStatus(b) ? -1 : 1
            }
          } else if (index[0] === 'name') {
            let nameA = (a.person[index] || '').toUpperCase()
            let nameB = (b.person[index] || '').toUpperCase()

            if (isDesc[0]) {             
              return nameB < nameA ? -1 : 1       
            } else { 
              return nameA < nameB ? -1 : 1
            }
          } 
        })
        return items
      },  
      isVessel (props) {
        return ((props.item.person || {}).user || {}).vessel !== null && ((props.item.person || {}).user || {}).vessel !== undefined
      },
      openProfile (employee) {
        this.employee = employee
        this.person = employee.person
        this.user = ((employee.person || {}).user || {}) || ''

        this.isProfile = true
      },
      hasPerson (props) {
        return props.item.person !== null
      },
      hasReportTo (reportTo) {
        return reportTo.person !== undefined
      },
      hasActiveBranch (props) {
        return (((props.item.person || {}).user || {}).active_branches || []).length > 0
      },
      setPaginationDetails (page) {
        this.total = page.total
        this.from = page.from
        this.to = page.to
        this.lastPage = page.last_page
        this.currentPage = page.current_page
        this.loadedPage = page.current_page
      },
      nextPage () {
        this.tableLoading = true
        if (this.currentPage + 1 > this.loadedPage) {
          this.$api.employees().overview('?page=' + (this.currentPage + 1), this.prepareFormData())
            .then(res => {
              this.setPaginationDetails(res.data)
              res.data.data.map(item => {
                this.employees.push(item)
              })
              this.tableLoading = false
            })
        } else {
          this.currentPage = this.currentPage + 1
          this.to = this.to + 10
          if (this.currentPage === this.lastPage) {
            this.to = (this.total % 10) + ((this.lastPage - 1) * 10)
          }
          this.from = this.from + 10
          this.tableLoading = false
        }
      },
      previousPage () {
        this.currentPage = this.currentPage - 1 
        if (this.currentPage === this.lastPage - 1) {
          this.to = this.to - (this.total % 10)
        } else {
          this.to = this.to - 10
        }
        this.from = this.from - 10
      },
      prepareFormData () {
        return {
          crmRoles: this.crm,
          amsRoles: this.ams,
          branches: this.branch,
          hrmRoles: this.hrm,
          lmsproRoles: this.lmspro,
          positions: this.position,
          companies: this.company,
          searchInput: this.searchInput,
        }
      },
      clearFilter () {
        this.crm = null
        this.ams = null
        this.branch = null
        this.hrm = null
        this.lmspro = null
        this.position = null
        this.searchInput = null
        this.company = null
        this.loadUserOverview()
      },
    },
  }
</script>

<style scoped>
  .disabled {
      color: grey;
      pointer-events: none;
  }

  ::v-deep .v-toolbar__content{
    margin-left:0px !important;
  }

  @keyframes metronome-example {
    from {
      transform: scale(.5);
    }

    to {
      transform: scale(1);
    }
  }

  .v-avatar--metronome {
    animation-name: metronome-example;
    animation-iteration-count: infinite;
    animation-direction: alternate;
  }

  .align-right{
    text-align: right;
  }

  .pagination{
    font-size:12px;
    color:#5F6368
  }

  .cursor-pointer{
    cursor: pointer;
  }
</style>
